document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-size-chart-trigger]');
  if (trigger) {
    const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    return;
  }

  const closeButton = event.target.closest('[data-size-chart-close]');
  if (closeButton) {
    closeButton.closest('dialog')?.close();
    return;
  }

  if (event.target.matches('dialog.size-chart__dialog')) {
    event.target.close();
  }
});
